import React, { Component } from 'react';
import { Grid, Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Select from 'react-select';
/* import DatePicker from "react-datepicker"; */

import { ConsultaMaterias, ConsultaSecciones, Guardar, verSeccion, Editar, Delete } from '../../funciones/RegistroFunction';
import { NuevasHoras } from '../../funciones/Validaciones';
import { toast } from 'react-toastify';

import CustomModal from "../../components/Modal/CustomModal";

let statusBtn = 0;
let idSeccion = null;
let codigo = "";

class Registro extends Component {
    state = {
        valorSemestre: { value: '', label: '- Selecciona un Nivel -' },
        semestres: [{ value: '', label: ' - Cargando Espere - ', num: '' }],
        valorMateria: { value: '', label: '- Selecciona una Materia -' },
        materias: [{ value: '', label: ' - Selecciona un Nivel - ', codigo: '' }],
        valorProfe: { value: '', label: '- Selecciona un Profesor -' },
        profesores: [{ value: '', label: ' - Cargando lista de profesores - ' }],

        preloader:{ icon: "", text: "" },
        preloaderSecc:{ icon: "", text: "" },
        textInfo: <React.Fragment>Para agregar una nueva sección indica primero el <strong>Nivel</strong> a tu izquierda</React.Fragment>,
        openDelSec: false,

        seccionesDisp: [{ id: "", codigo: "", materia: "", seccion: "" }],

        cantErrores: "",
        codigo:  { text: "", status: "" },
        nombre:  { text: "", status: "" },
        cupos:  { text: "", status: "" },
        aula:  { text: "", status: "" },
        cohorte:  { text: "", status: "" },
        hora1: "",
        hora2: "",
        
        boton1: { Icon:"fa fa-save", Title:"Guardar", disabled: ""},
        boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
        boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
        boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
    }

    componentWillMount = () => {
        statusBtn = 0;
        this.setState({profesores: this.props.profesores})
        this.setState({semestres: this.props.semestres})
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",
            },
            openDelSec: false
        });
    };

    cambiaValor2 = (prop) => (event) => {
        this.setState({
            [prop]:(event.target.value).toUpperCase(),
            openDelSec: false
        });
    };


    cambiaValorNombre = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",

            },
            openDelSec: false,
            codigo:{
                text:`${codigo}-${(event.target.value).toUpperCase()}`,
                status: "",
            }
        });
    };

    openWDelSec = () => {
        this.setState ({ openDelSec: true })
    }

    valorMateria = (valorMateria) => {
        codigo = `${this.state.valorSemestre.value}-${valorMateria.codigo}`;
        this.setState({
            codigo:  {
                text: codigo,
                status: ""
            },
            valorMateria,
            openDelSec: false
        })
    }
    valorProfe = (valorProfe) => { this.setState({valorProfe, openDelSec: false}) }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Cargando"
            },
            textInfo: <React.Fragment>Haz seleccionado <strong>{valorSemestre.label}</strong></React.Fragment>,
            openDelSec: false
        },() => {
            ConsultaMaterias(valorSemestre.value, (resp) => {
                this.setState ({materias: resp, preloader:""})
            })
            ConsultaSecciones (valorSemestre.value, (resp) => {
                this.setState ({seccionesDisp: resp})
            })
        });
    }

    seccionesDisp = () => {
        let { seccionesDisp } = this.state;
        if (seccionesDisp[0] === undefined) return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                No existen secciones disponibles para este Nivel
            </div> 
        )
        
        if (seccionesDisp[0].id === "") return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                Primero selecciona un <strong>Nivel</strong> para mostrar las secciones disponibles
            </div> 
        )

        let contenidoSeccion = () => {
            return(
                seccionesDisp.map(option => (
                    <tr onClick = {this.editSeccion (option.id)} key={option.id} style={{cursor: "pointer"}} title = {`Haz Click para editar ${option.materia}`}>
                        <td style={{fontSize: 10}} align= "center">{option.codigo}</td>
                        <td style={{fontSize: 10}}>{option.materia}</td>
                        <td style={{fontSize: 10}} align= "center">{option.seccion}</td>
                    </tr>
                ))
            )
        }

        return (
            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                <Table striped hover bordered>
                    <tbody>
                        <tr>
                            <td width="30%" align= "center" style={{padding: 3, fontSize: 10}}><strong>Código</strong></td>
                            <td width="50%" align= "center" style={{padding: 3, fontSize: 10}}><strong>Materia</strong></td>
                            <td width="20%" align= "center" style={{padding: 3, fontSize: 10}}><strong>Sección</strong></td>
                        </tr>
                        {contenidoSeccion()}
                    </tbody>
                </Table>
            </div>
        );
    }

    editSeccion = (id) => (e) => {
        statusBtn = 1;
        idSeccion = id;

        this.setState ({
            openDelSec: false,
            preloaderSecc:{ icon: "fa fa-spinner fa-spin", text: "" },
            boton2: { Icon:"fa fa-times", Title:"", disabled: "disabled"},
            boton3: { Icon:"fa fa-edit", Title:"", disabled: "disabled"},
            boton4: { Icon:"fa fa-trash", Title:"", disabled: "disabled"},
        }, () => {
            verSeccion (id, (resp) => {
                this.setState(resp)
            })
        })
    }

    cancelar = () => {
        statusBtn = 0;
        idSeccion = null;
        this.setState ({
            valorMateria: { value: '', label: '- Selecciona una Materia -' },
            valorProfe: { value: '', label: '- Selecciona un Profesor -' },
            cantErrores: "",
            codigo:  { text:"", status: "" },
            nombre:  { text:"", status: "" },
            cupos:  { text:"", status: "" },
            aula:  { text:"", status: "" },
            cohorte:  { text:"", status: "" },
            hora1: "",
            hora2: "",
            openDelSec: false,
        }) 
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let mateOk = (mensaje) => {
            let { valorSemestre } = this.state;
            if (valorSemestre.value !== ""){
                ConsultaMaterias(valorSemestre.value, (resp) => { this.setState(resp) })
                ConsultaSecciones (valorSemestre.value, (resp) => { this.setState ({seccionesDisp: resp}) })
            }

            this.setState({
                boton1:{
                    Icon:"fa fa-save",
                    Title:"Guardar",
                }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }
        
        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.cancelar()
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        mateOk(mensaje[0]);
    }

    respuestaEditar= (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let mateOk = (mensaje) => {
            let { valorSemestre } = this.state;
            if (valorSemestre.value !== ""){
                ConsultaMaterias(valorSemestre.value, (resp) => { this.setState(resp) })
                ConsultaSecciones (valorSemestre.value, (resp) => { this.setState ({seccionesDisp: resp}) })
            }

            this.setState({
                boton3:{ Icon:"fa fa-edit" }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }
        
        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        mateOk(mensaje[0]);
    }

    delSeccion = () => {
        let { nombre, valorSemestre, valorMateria } = this.state;
        let contenidoModal = <div>
            ¿Desea realmente <strong>eliminar la Sección <span className="text-info">{nombre.text}</span></strong> de <strong className="text-danger">{valorMateria.label}</strong>  del Sistema?
            </div>
        return (
            <CustomModal
                isopen =  {this.state.openDelSec}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = "Si"
                boton2 = "No"
                funcion1 = { Delete(idSeccion, (resp) => {
                    if (valorSemestre.value !== ""){
                        ConsultaMaterias(valorSemestre.value, (resp) => { this.setState(resp) })
                        ConsultaSecciones (valorSemestre.value, (resp) => { this.setState ({seccionesDisp: resp}) })
                    } 
                    toast.info("La Sección fue eliminada exisosamente",{autoClose: 4000});
                    this.cancelar()
                })}/>
        );
    }

    botones = () => {
        let { boton1, boton2, boton3, boton4, valorSemestre, valorMateria, valorProfe, codigo, nombre, cupos,
            hora1, hora2, aula, cohorte } = this.state;
        const campos = { valorSemestre, valorMateria, valorProfe, codigo, nombre, cupos, hora1, hora2, aula,
            cohorte }
        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary" disabled={boton1.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                        this.setState({
                            boton1:{ Icon: "fa fa-spinner fa-spin", Title: "Cargando" }
                        }, () => {
                            Guardar (campos, (resp) => { this.respuestaGuardar(resp) })
                        })
                    }} ><i className={boton1.Icon}></i> {boton1.Title}</button>
                )
            case 1:
                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-primary"  disabled={boton2.disabled} onClick ={this.cancelar} title="Cancelar" style={{borderWidth: 1}}><i className={boton2.Icon}></i></button>
                        <button className="btn btn-warning"  disabled={boton3.disabled}
                        onClick={ (e) => {
                            this.setState({
                                boton3:{ Icon: "fa fa-spinner fa-spin" },
                                openDelSec: false
                            }, () => {
                                Editar (idSeccion, campos, (resp) => { this.respuestaEditar(resp) })
                            })
                        }}
                        title="Editar esta Sección" style={{borderWidth: 1}}><i className={boton3.Icon}></i></button>
                        <button className="btn btn-danger" disabled={boton4.disabled} onClick={this.openWDelSec} title="Eliminar esta Sección" style={{borderWidth: 1}}><i className={boton4.Icon}></i></button>
                    </div>
                )
            default:
                return (<div></div>)
        }
    }

    secciones = () => {
        let { valorSemestre, semestres, preloader } = this.state;

        return (
            <div className="custom-alert-info" style={{padding: 10}}>
                <Select
                    isSearchable ={true}
                    value={valorSemestre}
                    onChange={this.valorSelectSemestre}
                    options={semestres}
                />
                <div align="center" style={{marginTop:5}}><i className={preloader.icon}></i>{preloader.text}</div>
                <div style={{ overflowY :"auto", height:"45vh",}}>{this.seccionesDisp()}</div>
            </div>
        )
    }

    registro = () => {
        let { preloaderSecc, textInfo, valorMateria, materias, codigo, nombre, cupos, aula, cohorte,
            valorProfe, profesores, hora1, hora2, cantErrores } = this.state;

        let MainAyuda = (
            <Popover title="Registro de Secciones" id="secc">
                <div align="justify">
                    Para Registrar las secciones, es necesario que selecciones primero el <strong>Nivel</strong> a tu izquierda,
                    luego completa los campos para registrarla.<hr/>
                    También puedes hacer <strong>Click</strong> en alguna sección para editarla.<hr/>
                    <div>
                        Si la hora de entrada y salida no se encuentra disponible, simplemente deja ambas en <strong>7:00 AM</strong> y el sistema
                        automáticamente las omitirá.
                    </div><hr/>
                    <div align="center" style={{fontSize: 10, fontWeight:"bold", paddingTop: 5}} className="custom-alert-warning">
                        Este paso es necesario para poder crear la <strong>Oferta Académica</strong>
                    </div>
                </div>
            </Popover>
        )

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        return (
            <React.Fragment>
                <div className="custom-alert-success">
                    <Row>
                        <Col md={9} style={{paddingTop: 8, paddingLeft: 25}}>
                        <span><i className={preloaderSecc.icon}></i>{preloaderSecc.text}</span> {textInfo}
                        </Col>
                        <Col md={3} align="right">
                            <OverlayTrigger trigger="focus" placement="left" overlay={ MainAyuda }>
                                <button className="btn btn-relleno-success" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i></button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </div>
                <Row className="custom-mt-20">
                    <Col md={5}>
                        <Select
                            styles={{menu: customStyles}}
                            isSearchable ={true}
                            value={valorMateria}
                            onChange={this.valorMateria}
                            options={materias}
                        />
                    </Col>
                    <Col md={4}>
                        <div className={codigo.status}>
                            <input type="text" disabled value={codigo.text} title= "Código de la Sección" className="form-control" placeholder="* Código de la Sección"/>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className={nombre.status}>
                            <input type="text" value={nombre.text} title= "Nombre de la Sección" onChange={this.cambiaValorNombre("nombre")} className="form-control" placeholder="* Nombre de la Sección"/>
                        </div>
                    </Col>

                    <Col md={5} className="custom-mt-30">
                        <Select
                            isSearchable ={true}
                            value={valorProfe}
                            onChange={this.valorProfe}
                            options={profesores}
                        />
                    </Col>
                
                    <Col md={7} className="custom-mt-10">
                        <span>Observaciones</span>
                        <input type="text" maxLength={190} className="form-control" value={hora2} onChange={this.cambiaValor2("hora2")} placeholder="Observaciones"/>
                    </Col>

                    <Col md={4} className="custom-mt-10">
                        <span>Horario</span>
                        <input type="text" className="form-control" value={hora1} onChange={this.cambiaValor2("hora1")} placeholder="Horario"/>
                    </Col>

                    <Col md={4} className="custom-mt-10">
                        <span>Aula</span>
                        <div className={aula.status}>
                            <input type="text" value={aula.text} onChange={this.cambiaValor("aula")} className="form-control" placeholder="Aula"/>
                        </div>
                    </Col>
                    <Col md={4} className="custom-mt-10">
                        <span>Cupos</span>
                        <div className={cupos.status}>
                            <input type="text" value={cupos.text} onChange={this.cambiaValor("cupos")} className="form-control" placeholder="* Cupos"/>
                        </div>
                    </Col>
                    {/* <Col md={4} className="custom-mt-20">
                        <div className={cohorte.status}>
                            <input style={{display:"none"}} type="text" value={cohorte.text} onChange={this.cambiaValor("cohorte")} className="form-control" placeholder=" Periodo - Cohorte"/>
                        </div>
                    </Col> */}

                    <Col md ={7} className="custom-mt-20"><div className="text-danger">{ cantErrores }</div></Col>
                    <Col md={5} className="custom-mt-30" align="right">
                        {this.botones()}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    render() { 
        return (
            <Grid fluid>
                <Row>
                    <Col md={4}>{this.secciones()}</Col>
                    <Col md={8}>{this.registro()}</Col>
                </Row>
                {this.delSeccion()}
            </Grid>
        );
    }
}
 
export default Registro;


// WEBPACK FOOTER //
// ./src/views/Secciones/Registro.jsx